import $ from 'jquery';
/**
 * Enables the "home" page functionality.
 */
const enableHomeFunctionality = () => {
    if ($('#home').length === 0) {
        return;
    }
    // change the "Donate" button image on hover
    $('.nav-item form input[type=image]')
        .on('mouseenter', function () {
        const $input = $(this);
        $input.attr('src', '/img/donate-button-hover.png');
    })
        .on('mouseleave', function () {
        const $input = $(this);
        $input.attr('src', '/img/donate-button.png');
    });
    // scroll to the anchor when clicking on navigation links
    $('.nav-item.scroll').on('click', function (e) {
        e.preventDefault();
        const $header = $('header');
        const $link = $($('.nav-link', $(this)).attr('href') || ''); // the href attribute of each scroll link is a selector for the link section
        const linkOffset = $link.offset();
        let linkTop = 0;
        if (linkOffset) {
            linkTop = linkOffset.top;
        }
        $('html, body').animate({
            scrollTop: (linkTop - ($header.outerHeight() || 0))
        }, 'slow');
    });
    // enable "back to top" functionality
    $('#back-to-top, #undaf-logo').on('click', function (e) {
        if (window.location.pathname === '/') {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 800);
        }
    });
};
export default enableHomeFunctionality;
